import { render, staticRenderFns } from "./OrderedListItem.vue?vue&type=template&id=7fc2a1f1"
import script from "./OrderedListItem.vue?vue&type=script&lang=js"
export * from "./OrderedListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports